export function getUserMenuLinks(role, navigate, logOut) {
    const userMenuLinks = {
        HOST_ADMIN: [
            { name: 'Dashboard', action: () => navigate('/') },
            { name: 'Properties', action: () => navigate('/dashboard/my-properties') },
            { name: 'Reservations', action: () => navigate('/dashboard/reservations'), divider: true },
            { name: 'Payout Details', action: () => navigate('/dashboard/payout-details') },
            { name: 'My Profile', action: () => navigate('/profile') },
            { name: 'Company Settings', action: () => navigate('/company'), divider: true },
            { name: 'Sign out', action: logOut },
        ],
        PROPERTY_MANAGER: [
            { name: 'Dashboard', action: () => navigate('/') },
            { name: 'Properties', action: () => navigate('/dashboard/my-properties') },
            { name: 'Reservations', action: () => navigate('/dashboard/reservations'), divider: true },
            { name: 'My Profile', action: () => navigate('/profile'), divider: true },
            { name: 'Sign out', action: logOut },
        ],
        FLEET_MANAGER: [
            { name: 'Dashboard', action: () => navigate('/') },
            { name: 'Fleets', action: () => navigate('/dashboard/fleet') },
            { name: 'Reservations', action: () => navigate('/dashboard/reservations'), divider: true },
            { name: 'Payment Methods', action: () => navigate('/dashboard/payment-methods') },
            { name: 'My Profile', action: () => navigate('/profile'), divider: true },
            { name: 'Sign out', action: logOut },
        ],
        CARRIER_ADMIN: [
            { name: 'Dashboard', action: () => navigate('/') },
            { name: 'Fleets', action: () => navigate('/dashboard/fleet') },
            { name: 'Reservations', action: () => navigate('/dashboard/reservations') },
            { name: 'Payment Methods', action: () => navigate('/dashboard/payment-methods'), divider: true },
            { name: 'My Profile', action: () => navigate('/profile') },
            { name: 'Company Settings', action: () => navigate('/company'), divider: true },
            { name: 'Sign out', action: logOut },
        ],
        DRIVER: [
            { name: 'Dashboard', action: () => navigate('/') },
            { name: 'Reservations', action: () => navigate('/dashboard/reservations'), divider: true },
            { name: 'Payment Methods', action: () => navigate('/dashboard/payment-methods') },
            { name: 'My Profile', action: () => navigate('/profile'), divider: true },
            { name: 'Sign out', action: logOut },
        ],
        PARKPRO_ADMIN: [
            { name: 'Dashboard', action: () => navigate('/') },
            { name: 'My Profile', action: () => navigate('/profile'), divider: true },
            { name: 'Sign out', action: logOut },
        ],
        PARKPRO_SUPER_ADMIN: [
            { name: 'Dashboard', action: () => navigate('/') },
            { name: 'All Users', action: () => navigate('/dashboard/super-admin/users') },
            { name: 'My Profile', action: () => navigate('/profile'), divider: true },
            { name: 'Sign out', action: logOut },
        ],
    };

    return userMenuLinks[role] || [{ name: 'Sign out', action: logOut }];
}
